import { render, staticRenderFns } from "./EventsMain.vue?vue&type=template&id=6feb0e02&"
import script from "./EventsMain.vue?vue&type=script&lang=js&"
export * from "./EventsMain.vue?vue&type=script&lang=js&"
import style0 from "./EventsMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports